var Component = require("!../../_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./slide.vue"),
  /* template */
  require("!!../../_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0d7cf710\"}!../../_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./slide.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-awesome-swiper@2.6.7@vue-awesome-swiper/src/slide.vue
// module id = 141
// module chunks = 19